import { render } from "./HubsynchUsing.vue?vue&type=template&id=bdda54c8"
import script from "./HubsynchUsing.vue?vue&type=script&setup=true&lang=js"
export * from "./HubsynchUsing.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/HubsynchUsing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bdda54c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bdda54c8', __exports__)) {
    api.reload('bdda54c8', __exports__)
  }
  
  module.hot.accept("./HubsynchUsing.vue?vue&type=template&id=bdda54c8", () => {
    api.rerender('bdda54c8', render)
  })

}


export default __exports__